import { DateFormatNow } from '@/components/date-format-now/DateFormatNow';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { ApiFieldListShowType } from '@/shared/constant/ApiFieldList';
import clsx from 'clsx';
import React from 'react';

export type LastModifiedAtProps = {
  className?: string;
};

export function LastModifiedAt(props: LastModifiedAtProps) {
  const { className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const locale = useDocsDataModelStore((x) => x.docsBaseConfig.language);
  const isShowLastModifiedAt = useDocsDataModelStore((x) => x.docsBaseConfig.isShowLastModifiedAt);

  const apiFieldList = useDocsDataModelStore((x) => x.resourceData.extraData.apiFieldList);
  const lastModifiedAt = React.useMemo(() => {
    const field = apiFieldList.find(
      (x) => x.type === ApiFieldListShowType.Date && x.key === 'updateAt',
    );
    if (!field || field.type !== ApiFieldListShowType.Date) {
      return undefined;
    }
    return field;
  }, [apiFieldList]);

  if (lastModifiedAt === undefined || !isShowLastModifiedAt) {
    return null;
  }
  return (
    <div className={clsx('text-semi-lg font-400 text-fill-7', className)}>
      <span>{clientI18n('modified.at.label')}&nbsp;</span>
      <DateFormatNow value={lastModifiedAt.value} format={lastModifiedAt.format} locale={locale} />
    </div>
  );
}
